import {
  UnifiedLearningCertification,
  UnifiedLearningCertificationEdges,
} from 'constants/types';
import { UnifiedLearningCertificationQuery$data } from '~graphql/__generated__/UnifiedLearningCertificationQuery.graphql';

export const getNormalizedCertmetricsCertificates = (
  data: UnifiedLearningCertificationQuery$data,
): UnifiedLearningCertification[] | undefined => {
  const edges: UnifiedLearningCertificationEdges =
    data.unified?.unifiedProfile?.learning?.certifications?.edges;

  if (!edges) {
    return;
  }

  return edges.reduce<UnifiedLearningCertification[]>(
    (normalizedCertmetricsCertificates, currentEdge) => {
      if (currentEdge?.node) {
        normalizedCertmetricsCertificates.push(currentEdge.node);
      }

      return normalizedCertmetricsCertificates;
    },
    [],
  );
};
